(function($) {
  'use strict';

  // Homepage
  // ====================================================
  let $overlay = $(".slide--overlay"),
      $media = $(".slide--image *"),
      $contentParent = $(".slide--content"),
      $timing = 6000; // Change time to next slide here, also affects progress bars




  function initAnimation() {
    $overlay.stop().delay(300).animate({
      'opacity' : '1',
    }, 500);

    $media.stop().animate({
      'width' : '115%',
      'opacity' : '1',
    }, 1000);

    $contentParent.find("h1").stop().delay(600).animate({
      'opacity' : '1',
      'top' : '0',
    }, 400);

    if ( $contentParent.find("p").length ) {
      $contentParent.find("p").stop().delay(700).animate({
        'opacity' : '1',
        'top' : '0',
      }, 500);
    }

    $contentParent.find("a").stop().delay(800).animate({
      'opacity' : '1',
      'top' : '0',
    }, 600);

    $(".js-slider--banner-homepage-nav .slick-current").find(".js-progressbar--progress").stop().animate({
      'width' : '100%',
    }, $timing);
  }

  function clearAnimation() {
    $overlay.stop().animate({
      'opacity' : '0',
    }, 200);

    $media.stop().animate({
      'width' : '101%',
      'opacity' : '0',
    }, 200);

    $contentParent.find("h1").stop().animate({
      'opacity' : '0',
      'top' : '25px',
    }, 200);

    if ( $contentParent.find("p").length ) {
      $contentParent.find("p").stop().animate({
        'opacity' : '0',
        'top' : '25px',
      }, 200);
    }

    $contentParent.find("a").stop().animate({
      'opacity' : '0',
      'top' : '25px',
    }, 200);

    $(".js-slider--banner-homepage-nav").find(".js-progressbar--progress").stop().animate({
      'width' : '0',
    }, 10);
  }

  window.addEventListener('load', initAnimation);

  $(".js-slider--banner-homepage").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: $timing,
    cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    dots: false,
    fade: true,
    speed: 500,
    asNavFor: '.js-slider--banner-homepage-nav',
  })
    .on('beforeChange', clearAnimation)
    .on('afterChange', initAnimation);

  $(".js-slider--banner-homepage-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: $timing,
    asNavFor: '.js-slider--banner-homepage',
    centerMode: true,
    focusOnSelect: true,
    dots: false,
    arrows: false,
    infinite: true,
  });

  // catch tablet orientation change for homepage slider bars glitch on iPad Pro/other tablet devices
  $(window).on('orientationchange', function() {
    $('.js-slider--banner-homepage-nav').slick('reinit');
  });

  // Content Top
  // ====================================================
  $(".js-slider--content-top").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    dots: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        }
      },
    ],
  });


  // Related Products
  // ====================================================
  $(".js-slider--related-products").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    dots: false,
  });

  // Related Services
  // ====================================================
  $(".js-slider--related-services").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    dots: false,
  });

  // Feature Callout
  // ====================================================
  $(".js-slider--feature-callout").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      },
    ],
  });

  // Events
  // ====================================================
  $(".js-slider--events").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      },
    ],
  });

})(jQuery);
